const ko = {
  swap: '스왑',
  bridge: '브리지',
  markets: '마켓',
  comingSoon: '곧 출시 예정',
  copied: '복사됨',
  searchTokens: '토큰 검색',
  recentSearches: '최근 검색',
  popularTokens: '인기 토큰',
  noSearchContent: '토큰을 찾을 수 없습니다.',
  tokenSearch: '토큰 검색',

  header: {
    buyToken: '암호화폐 구매',
    searchTokens: '토큰 검색',
    recentSearches: '최근 검색',
    popularTokens: '인기 토큰',
    noSearchContent: '토큰을 찾을 수 없습니다.',
    markets: '마켓',
    inscribeTool: '기록 도구',
    trade: '거래',
    bridge: '스왑 & 브리지',
    bridgeDesc:
      '우리 DEX와 크로스 체인 집합기를 통해 토큰을 거래하고 브리지하세요.',
    advanced: '고급',
    advancedDesc:
      '더 종합적인 온체인 데이터 분석과 고급 거래 기능으로 거래하세요.',
  },

  appSetting: {
    theme: '테마',
    light: '라이트',
    dark: '다크',
    auto: '자동',

    language: '언어',
    langText: '영어',

    showChart: '차트 표시',
    contactUs: '문의하기',
  },

  stake: {
    know: {
      title: 'TPT 스테이킹으로 xTPT 얻기',
      desc: 'TPT를 스테이킹하여 xTPT를 얻고, 이를 사용해 생태계 개선 제안에 투표할 수 있습니다. 언제든지 xTPT를 TPT로 교환할 수 있습니다.',
    },
    join: '스테이킹된 TPT',
    connectWallet: '지갑 연결',
    networkNotvalid: 'BSC 네트워크로 전환해주세요',
    approve: '승인',
    unstake: '스테이킹 해제',
    add: '추가',
    loginFirst: '-',
    deposit: 'TPT 입금',
    withdraw: 'TPT 출금',
    balance: '잔액',
    confirm: '확인',
    overbalance: '잔액 초과',
    success: '성공',
    all: '전체',
    voteTip: 'xTPT를 사용해 지원하는 제안에 투표하세요!',
    goVote: '투표하기',
  },

  fee: {
    desc: 'Transit Swap은 사용자의 계정 주소에 보유된 TPT와 xTPT의 합계에 해당하는 할인율을 적용하는 거래 수수료 할인 기능을 시작합니다. 현재 4단계의 할인 레벨이 있으며, 앞으로 실제 상황에 맞춰 추가 레벨이 나눠질 예정입니다.',
    feeDiscount: '할인율',
    walletBalance: '잔액',
    levelRank: '레벨',
    levelBalance: '잔액 (TPT 및 xTPT)',
    levelDiscountRate: '할인율',
  },

  donation: {
    know: {
      title: 'Transit Swap 기부 풀 정의:',
      desc: 'Transit Swap 프로젝트는 개별 사용자로부터 토큰 기부를 받습니다. 모든 기부는 기부 풀로 들어가며, Transit Swap 프로젝트 운영 및 생태계 관련 자금에 사용됩니다.',
    },
    tip: {
      title: '중요 알림:',
      desc:
        'Transit Swap 프로젝트는 기부자에게 보상금을 제공하지 않습니다. 기부자는 기부 해시가 생성된 후 72시간 내에 기부를 반환할 수 있으며, 이후 요청은 처리되지 않습니다.\n' +
        '우리가 받는 기부 토큰 종류: TPT\n',
    },
    donateType: {
      title: '기부를 받을 주소',
      desc: 'TPT',
    },
    address: {
      title: '기부를 받을 주소:',
    },
    join: '기부하기',
    donateChain: '체인 선택',
    connectWallet: '지갑 연결',
    donateTip: {
      title: '주의:',
      desc: 'Transit Swap은 기부자에게 보상금을 제공하지 않습니다. 기부 후 후회할 경우, 72시간 이내에 거래 해시를 공식 이메일로 보내 반환 요청을 할 수 있습니다.',
    },
    warn: '먼저 체인을 선택해주세요',
    transfer: 'TPT 기부를 위해 TokenPocket으로 이 QR 코드를 스캔해주세요',
    copyAddress: '주소 복사',
    copied: '복사됨',
    yourAddress: '귀하의 주소',
    cantDonate: '현재 체인에서는 기부를 지원하지 않습니다',
    confirmDonate: '기부 확인',
    donateSuccess: '기부 성공',
    donateFail: '기부 실패',
    overCount: '잔액 부족',
    donateAddress: '기부 주소',
    donateCount: '기부 금액 (TPT)',
    pleaseSwitch1: '네트워크를 ',
    pleaseSwitch2: '로 전환해주세요',
    downloadTP: '직접 기부할 수 없습니다, TokenPocket을 다운로드해주세요',
    connectTronLink: '먼저 TronLink를 연결해주세요',
    waitBlockConfirm: '제출됨',
    noZero: '기부 금액은 0일 수 없습니다',
  },

  home: {
    title_1: '최첨단 DEX 플랫폼의 힘으로',
    title_2: 'PRO처럼 거래하기',
    swap: '스왑',
    bridge: '브리지',
    startTrading: '거래 시작',
    viewMore: '더 보기',
    modal_contact_us: {
      title: '문의하기',
      text_1:
        '* Transit는 절대 먼저 연락하지 않습니다. 요금을 요청하지 않습니다.',
      text_2: 'Transit Buy에 문의하기',
      serviceEmail: '서비스 이메일',
      telegram: '텔레그램',
      tips: '질문은 OnRamp에 관한 것만 가능합니다.',
      desc1: 'Transit Finance 직원은 개인 메시지를 보내지 않습니다!',
      desc2:
        '주의! Transit 커뮤니티에 들어가고 있습니다, 누군가가 우리를 사칭하여 개인 메시지를 보낼 수 있습니다! 개인 메시지를 보내는 사람은 사기일 수 있습니다! 우리는 절대 먼저 연락하지 않습니다!',
      desc3: '이해했습니다, 입장하기',
      tg_text_1: 'Transit Finance 직원은 절대 먼저 연락하지 않습니다!',
      tg_text_2: '개인 메시지를 보내는 사람은 사기일 수 있습니다!',
      tg_text_3: '나는 개인 정보를 누구에게도 공유하지 않습니다!',
    },
    markets: {
      title: '마켓',
      text: '실시간 데이터를 얻고, 인기 있는 토큰을 발견하며, 시장📈📉 기능을 통해 더 스마트한 거래 결정을 내리세요.</span>',
      text_1: '곧 출시 예정',
    },
    onRamp: {
      title: '온램프',
      text: '최적의 토큰 구매 및 판매를 위한 다채로운 온/오프 램프 채널.',
    },
    swap_bridge: {
      title: '스왑 & 브리지',
      text: '최고의 DEX와 가격 최적화를 제공하며, 다양한 체인에서 뛰어난 전문성으로 거래를 최적화합니다. 또한, 우리는 전문적인 크로스 체인 브리지 서비스를 제공하여 자산 유동성을 원활하게 합니다.',
    },
    liquidity_options: {
      title: '데이터',
      text_1: '더 나은 유동성,',
      text_2: '더 나은 옵션',
      Chains: '체인',
      DEXs: 'DEX',
      Bridges: '브리지',
      Ramps: '램프',
      Tokens: '토큰',
    },
    other_features: {
      title: '기타 기능',
      NFT: {
        title: 'NFT',
        text_1: 'NFT 마켓플레이스',
        text_2: 'Transit NFT',
        text_3: 'NFT 디자인 공모전',
      },
      Governance: {
        title: '거버넌스',
        text_1: 'DAO',
        text_2: '기부',
        text_3: '수수료',
      },
    },
    get_start: {
      text_1: 'Transit와 함께 무한한 거래 가능성을 열어보세요',
      text_2: 'PRO처럼 거래하려면!',
      text_3: '시작하기',
    },
  },

  terms: {
    title: '이용 약관',
    text_1_1: '최종 수정일: 2023년 1월 1일',
    text_1_2:
      '본 이용 약관(이하 "약관")은 Transit와 그 계열사 또는 관련 회사(이하 "Transit", "우리는", "우리" 또는 "우리의")와 귀하 또는 귀하가 대표하는 회사 또는 다른 법적 실체(이하 "귀하" 또는 "귀하의") 간의 계약입니다.',
    text_1_3: '이 약관을 주의 깊게 읽으십시오. 이 약관은 귀하의',
    text_2_1: '1. 약관의 수정',
    text_2_2:
      '우리는 언제든지 이 약관을 수정할 권리를 보유합니다. 이러한 변경 사항은 귀하에게 추가 통지 없이 즉시 효력을 발생합니다. 수정된 약관에 동의하지 않으면 서비스를 계속 사용하지 않도록 하십시오.',
    text_3_1: '2. 서비스',
    text_3_2:
      '“스마트 계약”은 블록체인에서 토큰의 P2P 교환을 촉진하는 공개된 오픈소스 소프트웨어 프로그램입니다.',
    text_3_3:
      '“블록체인”은 분산 네트워크 구조를 기반으로 한 데이터베이스 기술로, 여러 노드에 의해 유지되고 업데이트됩니다.',
    text_3_4:
      'Transit는 사용자가 Transit 스마트 계약과 상호 작용할 수 있는 소프트웨어를 개발했습니다.',
    text_3_5:
      '“Transit 네트워크”는 Transit 스마트 계약과 상호 작용하는 모든 사용자, 회사, 애플리케이션 및 기타 장치, 서비스 및 직원을 포함합니다.',
    text_3_6: '서비스 이용 시 거래 수수료("수수료")를 부과할 수 있습니다.',
    text_4_1: '3. 이용 약관',
    text_4_2: '서비스 및 웹사이트를 이용하는 조건으로, 귀하는:',
    text_4_3: '· 합법적인 목적으로만 서비스를 이용해야 합니다.',
    text_4_4: '· 제공하는 정보가 정확하고 완전하며 최신이어야 합니다.',
    text_4_5: '· 모든 관련 법규를 준수해야 합니다.',
    text_5_1: '5. 권리의 보유',
    text_5_2: '우리는 서비스를 종료하거나 제한할 수 있는 권리를 보유합니다.',
  },

  privacy_policy: {
    title: '개인 정보 보호 정책',
    text_1_1: '최종 수정일: 2024년 2월 2일',
    text_1_2:
      'Transit.Finance는 귀하의 개인정보 보호에 전념하고 있습니다. 본 개인정보 보호 정책은 귀하의 개인정보 수집, 사용, 공유 방법 및 관련 권리를 설명합니다.',
  },

  footer: {
    Features: {
      title: '기능',
      swap: '스왑&브리지',
      bridge: '브리지',
      market: '마켓',
      buyCrypto: '암호화폐 구매',
      explorer: '익스플로러',
    },
    NFT: {
      title: 'NFT',
      design: '디자인',
      transitNFT: 'Transit NFT',
      marketplace: '마켓플레이스',
    },
    Governance: {
      title: '거버넌스',
      dao: 'DAO',
      donation: '기부',
      fee: '수수료',
    },
    Community: {
      title: '커뮤니티',
      developers: '개발자',
      forum: '포럼',
      twitter: '트위터',
      downloadTP: 'TP 다운로드',
    },
    Help: {
      title: '도움말',
      contactUs: '문의하기',
      helpCenter: '도움말 센터',
    },
    Links: {
      title: '링크',
      TP: 'TokenPocket',
      Trading_View: '트레이딩 뷰',
      Terms: '이용 약관',
      Privacy_Policy: '개인 정보 보호 정책',
      bugBounty: '버그 바운티',
    },
  },

  option: {
    vol: '거래량',
    marketCap: '시가총액',
    price: '가격',
    price_1: '가격',
    chg: '변동',
    change: '변동률',
    bal: '잔액',
    pnl: '손익',
    txCount: '거래 수',
    holderCount: '보유자 수',
    createTime: '생성 시간',
    token: '토큰',
    age: '존재 기간',
    traders: '거래자',
    name: '이름',
    progress: '결합 진행',
    wallet: '지갑',
    balance: '잔액',
    pnl7d: '7일 손익',
    pnl30d: '30일 손익',
    txCount7d: '7일 거래 수',
    lastActive: '최근 활동',
  },

  brandkit: {
    title: '브랜드 자료',
    download: '자료 다운로드',
    desc: '여기에서 Transit의 공식 로고와 색상 팔레트를 확인할 수 있으며, 프로젝트에서 브랜드를 올바르게 표현할 수 있습니다. 브랜드 가이드라인에 따라 이러한 자료를 활용하여 Transit의 일관성과 전문성을 보장해 주세요.',
    logoDownload: '로고 다운로드',
    logoDownloadDesc:
      '지금 브랜드 로고를 다운로드하여 디자인 프로젝트가 일관되고 전문적인 이미지를 유지하도록 하세요.',
    logoDownloadDesc_1:
      '모든 파일은 고품질이며 웹, 인쇄 및 다양한 용도에 적합하여 손쉽게 뛰어난 시각 자료를 제작할 수 있습니다.',
    colorVersion: '컬러 버전',
    whiteVersion: '화이트 버전',
    brandTrademark: '브랜드 상표',
    brandTrademarkDesc: 'Transit 아이콘은 주로 대문자 "T"로 구성되어 있습니다;',
    brandTrademarkDesc_2: '텍스트 부분은 Transit입니다;',
    brandTrademarkDesc_3:
      '아이콘과 텍스트는 함께 Transit 브랜드의 상표를 형성합니다.',
    logo: '로고',
    fullVertical: '전체 세로형',
    fullHorizontal: '전체 가로형',
    spellingRules: '철자 규칙',
    spellingRulesDesc: '브랜드를 표시할 때: TRANSIT',
    spellingRulesDesc_1: '앱을 표시할 때: Transit',
    spellingRulesDesc_2: '잘못된 예시: TRANSITAPP, Transitapp, transitapp',
    representingBrand: '브랜드를 표시할 때',
    applicationBrand: '앱을 표시할 때',
    TransitIcon: 'Transit 아이콘',
    TransitIconDesc:
      'Transit이 애플리케이션으로 언급될 때 앱 아이콘을 사용하세요;',
    TransitIconDesc_1:
      'Twitter, Facebook, Medium, Telegram과 같은 소셜 미디어에서는 소셜 아바타를 사용하세요.',
    roundedIcon: '둥근 아이콘',
    squareIcon: '사각 아이콘',
    socialAvatar: '소셜 아바타',
    TransitColor: 'Transit 색상',
    TransitColorDesc:
      'Transit의 브랜드 색상은 파란색으로, 인터넷의 기술과 신뢰를 상징합니다. 앱의 차트에도 그라데이션 색상이 사용됩니다.',
    primary: '주색',
    secondary: '보조색',
    colorSystem: '색상 시스템',
    brandBlue: '브랜드 블루',
    brandBlack: '브랜드 블랙',
    OffWhite: '오프 화이트',
    palette: '팔레트',
  },
};

export default ko;
